
/**
 * @export
 * @enum {string}
 */
export enum AccountStatus {
    Client = 'Client',
    Merged_Client = 'Merged Client',
    Parent_Contract_Client = 'Parent Contract Client',
    CS_Non_Client = 'CS Non-Client',
    Parent_Client = 'Parent-Client',
    Prior_Client = 'Prior-Client',
    Contract_Client = 'Contract Client',
    Parent_Master_Client = 'Parent Master Client',
    Non_Client = 'Non-Client'
}